import React from 'react';

const CopyGraphicSvg = (props) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <path fill="#F6682F" d="M77 95H26V26h39l12 12z" />
            <path fill="#FFF" d="M78.5 38H65V26z" />
            <path stroke="#3A3A3A" strokeWidth={3} d="M65 27.5v12h12" />
            <path
                stroke="#3A3A3A"
                strokeWidth={3}
                d="M64.4 26l12.728 12.545V95H26.22V26z"
            />
            <path fill="#FFF" d="M116 117.5H65v-69h38.25L116 61.045z" />
            <path fill="#FFF" d="M117.5 60.5H104v-12z" />
            <path stroke="#3A3A3A" strokeWidth={3} d="M102.5 50v12H116" />
            <path
                stroke="#3A3A3A"
                strokeWidth={3}
                d="M103.25 48.5L116 61.045V117.5H65v-69zM82.565 32h8.06c1.779 0 3.223 1.424 3.223 3.183v7.957M60.008 111.571h-8.06c-1.78 0-3.223-1.426-3.223-3.183v-7.957"
            />
            <path
                d="M72.9 59h22.565M72.9 65h22.565M72.9 71h35.46M72.9 77h35.46M72.9 83h35.46M72.9 89h35.46M72.9 95h35.46M72.9 101h35.46M72.9 107h35.46"
                stroke="#D2D6DF"
                strokeWidth={3}
            />
        </g>
    </svg>
);

CopyGraphicSvg.displayName = 'CopyGraphicSvg';
export default CopyGraphicSvg;
